import { useEffect, useRef, useState } from 'react';
import { Card } from '../../components/Card/Card';
import { useMe, useUpdateHousehold } from '../../store/queryHooks';
import { useUiStore } from '../../store/ui';
import styles from './HouseholdForm.module.css';

const DEBOUNCE_MS = 600;

export function HouseholdForm() {
  const me = useMe();
  const update = useUpdateHousehold();
  const setToast = useUiStore((s) => s.setToast);
  const [name, setName] = useState(me.data?.name ?? '');
  const [startDay, setStartDay] = useState<number>(me.data?.budget_start_day ?? 1);
  const nameTimer = useRef<number | null>(null);
  const startDayTimer = useRef<number | null>(null);

  useEffect(() => {
    if (me.data?.name !== undefined) setName(me.data.name);
  }, [me.data?.name]);

  useEffect(() => {
    if (me.data?.budget_start_day !== undefined) setStartDay(me.data.budget_start_day);
  }, [me.data?.budget_start_day]);

  function onNameChange(next: string) {
    setName(next);
    if (nameTimer.current !== null) window.clearTimeout(nameTimer.current);
    nameTimer.current = window.setTimeout(async () => {
      const trimmed = next.trim();
      if (trimmed === '' || trimmed === me.data?.name) return;
      try {
        await update.mutateAsync({ name: trimmed });
        setToast('Familienavn opdateret');
      } catch {
        setToast('Kunne ikke gemme familienavn');
      }
    }, DEBOUNCE_MS);
  }

  function onStartDayChange(next: number) {
    setStartDay(next);
    if (startDayTimer.current !== null) window.clearTimeout(startDayTimer.current);
    startDayTimer.current = window.setTimeout(async () => {
      const clamped = Math.max(1, Math.min(28, Math.round(next || 1)));
      if (clamped === me.data?.budget_start_day) return;
      try {
        await update.mutateAsync({ budget_start_day: clamped });
        setToast('Månedens startdag opdateret');
      } catch {
        setToast('Kunne ikke gemme startdag');
      }
    }, DEBOUNCE_MS);
  }

  return (
    <Card className={styles.card}>
      <h2 className={styles.title}>Husstand</h2>
      <div className={styles.row}>
        <span className={styles.label}>Familienavn</span>
        <input
          className={styles.input}
          value={name}
          placeholder="Familie…"
          onChange={(e) => onNameChange(e.target.value)}
        />
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Månedens startdag</span>
        <input
          className={styles.input}
          type="number"
          min={1}
          max={28}
          value={startDay}
          onChange={(e) => onStartDayChange(Number(e.target.value))}
        />
      </div>
      <div className={styles.hint}>
        Ved bank-import placeres posteringer med dato før startdagen i den forrige måned. Sæt fx
        til 25 hvis din løn falder den 25. og indkomsten skal tælle med i den nye måned.
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Valuta</span>
        <span className={styles.static}>DKK (kr.)</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Sprog</span>
        <span className={styles.static}>Dansk</span>
      </div>
    </Card>
  );
}
